import { useEffect, useRef } from "react";
import { calendlyUrl } from "../../config/links";

const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";

const loadCalendly = () =>
  new Promise((resolve, reject) => {
    if (window.Calendly) return resolve(window.Calendly);
    let s = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (!s) {
      s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      document.body.appendChild(s);
    }
    s.addEventListener("load", () => resolve(window.Calendly));
    s.addEventListener("error", reject);
  });

const BackLink = ({ onClick, children, testid }) => (
  <button type="button" onClick={onClick} className="mt-6 text-[14px] font-medium text-[#6b5320] underline decoration-[#e8b84a] underline-offset-4 transition-colors hover:text-[#17130c]" data-testid={testid}>{children}</button>
);

export const BookScreen = ({ name, email, onBack }) => {
  const ref = useRef(null);
  const url = calendlyUrl({ name, email });

  useEffect(() => {
    let cancelled = false;
    loadCalendly()
      .then((Calendly) => {
        if (cancelled || !ref.current || !Calendly) return;
        ref.current.innerHTML = "";
        Calendly.initInlineWidget({ url: `${url}&hide_gdpr_banner=1`, parentElement: ref.current, prefill: { name, email } });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [url, name, email]);

  return (
    <div data-testid="apply-book-screen">
      <p className="font-mono-plex text-[11px] tracking-[0.16em] text-[#8a6416]">Step 2 of 2 · Book your strategy call</p>
      <h2 className="font-display mt-3 text-5xl uppercase leading-none text-[#120e07] sm:text-6xl">Pick a time</h2>
      <p className="mt-4 text-[15px] leading-relaxed text-[#4a3f2a]">Thanks — you look like a good fit for a strategy call. Choose a time that works for you.</p>
      <div className="-mx-5 mt-6 overflow-hidden border-y border-[#e8b84a]/50 bg-white sm:mx-0 sm:rounded-xl sm:border" data-testid="calendly-container">
        <div ref={ref} className="calendly-inline-widget h-[700px] w-full min-w-[320px]" data-url={url} data-testid="calendly-inline-widget" />
      </div>
      <a href={url} target="_blank" rel="noopener noreferrer" className="mt-5 flex w-full items-center justify-center rounded-full border border-[#e8b84a]/60 bg-[#0a0a0a] px-6 py-4 text-[15px] font-bold tracking-[0.04em] text-[#f3d27c] transition-[transform,background-color] duration-200 hover:-translate-y-px hover:bg-black" data-testid="calendly-fallback-button">
        Open the calendar →
      </a>
      <BackLink onClick={onBack} testid="apply-back-button">← Back to application</BackLink>
    </div>
  );
};

export { BackLink };
